import styled from 'styled-components'
import { Button, Box, Colors } from '@pinchenterprisesnpm/friday-ui'

export const EditButton = styled(Button)`
  margin-right: ${({ theme: { mp } }) => `${mp.xs}`};
  font-size: 0.875em;

  > svg {
    font-size: 0.875rem;
  }
`

// TODO refactor in friday-ui to avoid this
export const NewEditButton = styled(Button)`
  margin-right: ${(props) => `${props.theme.mp.xs}`};
  font-size: 0.875em;
`
export const SectionContainer = styled(Box)`
  border-radius: 3px;
  padding: ${({ theme: { mp } }) => mp.md};
  margin-bottom: ${({ theme: { mp } }) => mp.md};
  border: 1px solid ${({ theme: { palette } }) => palette.border};
`

export const CalendarDay = styled.button<{ isSelected?: boolean }>`
  padding: 0;
  border: none;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
  vertical-align: middle;

  &:focus,
  &:hover {
    outline: none;
  }

  /* Remove excess padding and border in Firefox 4+ */
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  /* Corrects font smoothing for webkit */
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;

  display: inline-block;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 26px;
  font-size: ${({
    theme: {
      font: { sizes },
    },
  }) => sizes.small};
  border-radius: 4px;
  margin-right: 3px !important;
  border: 1px solid ${Colors.primary_500};
  background-color: ${({ isSelected }) => (isSelected ? Colors.primary_500 : Colors.white)};
  color: ${({ isSelected }) => (isSelected ? Colors.white : Colors.primary_500)};
`
